import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '../../service/translation.service';

@Component({
  selector: 'app-success-modal-without-check',
  templateUrl: './success-modal-without-check.component.html',
  styleUrls: ['./success-modal-without-check.component.css']
})
export class SuccessModalWithoutCheckComponent {
  complaintId: string;

  constructor(
    public dialogRef: MatDialogRef<SuccessModalWithoutCheckComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translation: TranslationService
  ) {
    this.complaintId = data.complaintId; // 👈 assign the passed data
  }

  onClose() {
    this.dialogRef.close();
  }
}
